import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import EmailAccountFactory from "../../Entity/Factories/EmailAccountFactory";

export default function* emailAccountList(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, "email-accounts");

    // Iterate through each raw email account data and convert them to objects.
    const emailAccounts = res.data.data.map(emailAccount => {
      return EmailAccountFactory.create(emailAccount);
    });

    yield put({
      type: Constants.GLOBAL_EMAIL_ACCOUNT_LIST_SUCCESS,
      payload: {
        emailAccounts: emailAccounts
      }
    });

  } catch (err) {
    // should signout user if entity could not be loaded
    yield put({
      type: Constants.PAGE_SIGNOUT_START
    });
    
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchEmailAccountList() {
  yield takeEvery(Constants.GLOBAL_EMAIL_ACCOUNT_LIST, emailAccountList);
}
